import { MultiplateChoice } from './MultiplateChoice';

export default MultiplateChoice;
